module.exports = __webpack_public_path__ + "media/fonts/ionicons-e5a4fae0.woff";